import { Stack, Switch, Typography } from '@mui/material';
import COLORS from '../../colors';

interface NetworkBreakdownSwitchProps {
  toggle: boolean;
  onSwitchChange: (checked: boolean) => void;
}

const NetworkBreakdownSwitch = ({
  toggle,
  onSwitchChange
}: NetworkBreakdownSwitchProps) => {
  const handleOnChange = (value: boolean): void => {
    onSwitchChange(value);
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography color={!toggle ? COLORS.NEUTRAL_200 : COLORS.NEUTRAL_500}>
        Buyer Defined
      </Typography>
      <Switch
        checked={toggle}
        onChange={(_, checked: boolean) => handleOnChange(checked)}
      />
      <Typography color={toggle ? COLORS.NEUTRAL_200 : COLORS.NEUTRAL_500}>
        TVNZ Optimise
      </Typography>
    </Stack>
  );
};

export default NetworkBreakdownSwitch;
